angular
  .module('app.filters')
  .filter('employerTypeAheadFilter', function filter() {
    return function employerTypeAhead(employers, query) {
      employers = employers || []

      var employerName = ''
      var employerNameWithoutApostrophe = ''
      var queryWithoutApostrophe = query.replaceAll('’', '').toLowerCase()

      return employers.filter(employer => {
        employerName = employer.name
        employerNameWithoutApostrophe = employerName
          ? employerName.replaceAll('’', "'").toLowerCase()
          : ''

        return employerNameWithoutApostrophe.contains(queryWithoutApostrophe)
      })
    }
  })



// WEBPACK FOOTER //
// ./scripts/shared/filters/employer-type-ahead.js